const $ = require("jquery");
const axios = require("axios");
const slick = require("slick-carousel");
const debounce = require("lodash.debounce");
import Elementary from "./vendor/elementary";

import babelPolyfill from "babel-polyfill";

import GdprBanner from "./modules/gdpr-banner";
GdprBanner();

// Object assign polyfill

if (typeof Object.assign !== "function") {
	// Must be writable: true, enumerable: false, configurable: true
	Object.defineProperty(Object, "assign", {
		value: function assign(target, varArgs) {
			// .length of function is 2
			"use strict";
			if (target === null || target === undefined) {
				throw new TypeError("Cannot convert undefined or null to object");
			}

			var to = Object(target);

			for (var index = 1; index < arguments.length; index++) {
				var nextSource = arguments[index];

				if (nextSource !== null && nextSource !== undefined) {
					for (var nextKey in nextSource) {
						// Avoid bugs when hasOwnProperty is shadowed
						if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
							to[nextKey] = nextSource[nextKey];
						}
					}
				}
			}
			return to;
		},
		writable: true,
		configurable: true,
	});
}

// ELEMENTARY --------------------------

Elementary();

// const elementary = require('./vendor/elementary.js');

// window.addEventListener( 'load', elementary, false );
// window.addEventListener( 'resize', elementary, false );

// HEADER IMG --------------------------------------------

import headerImg from "./modules/header-img.js";
headerImg();

// MOBILE NAV --------------------------------------------

const navTrigger = $("[data-nav-trigger]");
const navActiveClass = "js-mobile-nav-open";

navTrigger.on("click", function () {
	$("html").toggleClass(navActiveClass);
});

// HOMEPAGE VIDEO LOAD -----------------------------------
const vidEl = document.getElementById("home-video");

if (vidEl !== null) {
	const vidSource = vidEl.getElementsByTagName("source").item(0);

	function checkHomeVideo() {
		// If window is greater than breakpoint...
		if ($(window).width() >= 1024) {
			if (vidSource.hasAttribute("src") === false) {
				// vidSource.attr('src', vidSource.attr('data-src'));
				vidSource.setAttribute("src", vidSource.getAttribute("data-src"));
				vidEl.load();

				vidEl.addEventListener("loadeddata", function (e) {
					vidEl.parentElement.classList.add("loaded");
					vidEl.play();
				});
			}
		}
	}

	$(window).on("resize", debounce(checkHomeVideo, 200));
	checkHomeVideo();
}

// MINI CAROUSEL -----------------------------------------

const miniCarousels = $("[data-carousel-mini]");
const miniCarouselBp = 720;

// When resizing window check whether carousel should be shown or not
$(window).on("resize", debounce(checkMiniCarousel, 200));

function checkMiniCarousel() {
	// If window is less than carousel breakpoint...
	if ($(window).width() < miniCarouselBp) {
		// Initialise carousel
		miniCarousels.slick({
			prevArrow: '<button type="button" class="btn btn--arrow btn--arrow-prev"><span>Prev</span></button>',
			nextArrow: '<button type="button" class="btn btn--arrow btn--arrow-next"><span>Next</span></button>',
		});
	} else {
		// ..otherwise, loop through each carousel element
		miniCarousels.each(function () {
			// ...if slick initialized on element
			if ($(this).hasClass("slick-initialized")) {
				// Make copy of carousel items
				let slideItems = $(this).children(".mini-carousel__item").clone();
				// Destroy slick instance (which removes carousel items from DOM)
				$(this).slick("unslick");
				// Append copied items back into carousel element
				$(this).append(slideItems);
			}
		});
	}
}
checkMiniCarousel();

// TESIMONIALS CAROUSEL -----------------------------------------

const testimonialsCarousels = $("[data-testimonials-carousel]");
// Initialise carousel
testimonialsCarousels.slick({
	autoplay: true,
	arrows: false,
	dots: true,
	infinite: true,
	speed: 1000,
	autoplaySpeed: 7000,
	fade: true,
	customPaging: function (slider, i) {
		return $('<button type="button" />').html("<span>" + (i + 1) + "</span>");
	},
});

// GALLERY CAROUSEL -----------------------------------------

const galleryCarousels = $("[data-carousel-gallery]");
// Initialise carousel
galleryCarousels.each(function () {
	let parentGallery = $(this).parents(".gallery");
	let paginationEl = parentGallery.find(".gallery__pagination");
	$(this).on("init reInit afterChange", function (e, slick, currSlide, nextSlide) {
		let i = (currSlide ? currSlide : 0) + 1;
		console.log(i);
		console.log(slick.slideCount);
		paginationEl.text(i + "/" + slick.slideCount);
	});
	$(this).slick({
		infinite: true,
		prevArrow: '<button type="button" class="btn btn--arrow btn--arrow-prev"><span>Prev</span></button>',
		nextArrow: '<button type="button" class="btn btn--arrow btn--arrow-next"><span>Next</span></button>',
		appendArrows: parentGallery.find(".gallery__controls"),
		slidesToShow: 2,
		responsive: [
			{
				breakpoint: 1240,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});
});

// HEADER IMGS -------------------------------

const headerBgs = $(".site-header__bgs");
// Initialise carousel
headerBgs.slick({
	autoplay: true,
	arrows: false,
	dots: false,
	infinite: true,
	speed: 1000,
	autoplaySpeed: 4000,
	fade: true,
});

// Guide book option
const form = $("[data-booking-form]");
const guidebookFld = $("[data-guidebook-fld]");

form.on("submit", function (e) {
	if (guidebookFld.is(":checked")) {
		form.append('<input type="hidden" name="purchasables[1][id]" value="' + guidebookFld.val() + '">');
		form.append('<input type="hidden" name="purchasables[1][qty]" value="1">');
		form.append('<input type="hidden" name="purchasables[1][note]">');
		form.append('<input type="hidden" name="purchasables[1][options]">');
	}
	return true;
});

// EVENT FILTERS --------------------------------------

const filters = $("[data-filter-select]");
const currUrl = window.location.href;

filters.each(function () {
	let el = $(this);
	el.on("change", function (e) {
		el.parents("form").submit();
	});
});

// TIMELINE GALLERY

const timeLineGalleries = $("[data-timeline-gallery]");
const completeItemClass = "timeline-item--complete";
const activeItemClass = "timeline-item--active";
const galleryLoadedClass = "timeline-gallery--loaded";

$(document).ready(function () {
	timeLineGalleries.each(function () {
		let el = $(this);
		let carousel = el.find("[data-timeline-gallery-items]");
		let prevBtn = el.find("[data-timeline-gallery-prev]");
		let nextBtn = el.find("[data-timeline-gallery-next]");
		let timeline = el.find("[data-timeline-gallery-timeline]");
		let itemLinks = el.find("[data-timeline-gallery-item-link]");
		let progress = el.find("[data-timeline-gallery-progress]");

		// Position progress bar at correct start point
		let firstItem = itemLinks.eq(0).parent();
		progress.css("left", firstItem.outerWidth() / 2 + "px");

		prevBtn.on("click", function (e) {
			carousel.slick("slickPrev");
		});
		nextBtn.on("click", function (e) {
			carousel.slick("slickNext");
		});
		itemLinks.on("click", function (e) {
			e.preventDefault();
			let slideNum = $(this).attr("data-timeline-gallery-item-link") * 1;
			carousel.slick("slickGoTo", slideNum);
		});
		carousel.on("beforeChange", function (e, slick, currentSlide, nextSlide) {
			itemLinks.removeClass(completeItemClass + " " + activeItemClass);
			itemLinks.slice(0, nextSlide + 1).each(function () {
				$(this).addClass(completeItemClass);
			});
			itemLinks.eq(nextSlide).addClass(activeItemClass);

			moveTimeLine(el, nextSlide);

			// Disable prev/next buttons
			if (nextSlide == 0) {
				prevBtn.prop("disabled", true);
			} else {
				prevBtn.prop("disabled", false);
			}

			if (nextSlide + 1 == slick.slideCount) {
				nextBtn.prop("disabled", true);
			} else {
				nextBtn.prop("disabled", false);
			}
		});
		carousel.on("init", function () {
			console.log("initialized");
			el.addClass(galleryLoadedClass);
		});

		carousel.slick({
			infinite: false,
			arrows: false,
			dots: false,
			fade: true,
			speed: 500,
		});
	});

	function moveTimeLine(timelineGalleryEl, activeSlideNum = null) {
		let itemLinks = timelineGalleryEl.find("[data-timeline-gallery-item-link]");
		let firstItem = itemLinks.eq(0).parent();
		let timelineContainer = timelineGalleryEl.find("[data-timeline-gallery-timeline-container]");
		let timelineContainerWidth = timelineContainer.outerWidth();
		let timeline = timelineGalleryEl.find("[data-timeline-gallery-timeline]");
		let progress = timelineGalleryEl.find("[data-timeline-gallery-progress]");

		let activeItem = null;

		if (activeSlideNum !== null) {
			activeItem = itemLinks.eq(activeSlideNum).parent();
		} else {
			activeItem = timelineGalleryEl.find(".timeline-item--active").parent();
		}

		let activeItemOffset = activeItem.position().left;
		let translateAmount = activeItemOffset - timelineContainerWidth / 2 + firstItem.outerWidth() / 2;

		if (translateAmount < 0) {
			translateAmount = 0;
		}

		console.log("Active Item Offset", activeItemOffset);
		console.log("Translate Amount", translateAmount);

		timeline.css("transform", "translateX(-" + translateAmount + "px)");

		let progressWidth = activeItemOffset - firstItem.outerWidth() / 2 + activeItem.outerWidth() / 2;
		progress.css({
			width: progressWidth + "px",
			transform: "translateX(-" + translateAmount + "px)",
		});
	}

	function checkTimelineGalleries() {
		timeLineGalleries.each(function () {
			moveTimeLine($(this));
		});
	}

	$(window).on("resize", debounce(checkTimelineGalleries, 200));
});

// HEADER ALERTS

const headerAlertHiddenClass = "alert--header-hidden";
const hiddenAlertsStorage = localStorage.getItem("hidden-alerts");

$("[data-alert-header]").each(function () {
	let alert = $(this);
	let alertId = parseInt(alert.attr("data-alert-header"));
	let hideTrigger = alert.find("[data-alert-header-close]");
	let hiddenAlerts = JSON.parse(hiddenAlertsStorage);

	// If alert id not in local storage
	if (hiddenAlerts === null || hiddenAlerts.indexOf(alertId) === -1) {
		// Show alert after 1000ms
		window.setTimeout(function () {
			alert.removeClass(headerAlertHiddenClass);
		}, 1000);
	}

	// When alert close button clicked
	hideTrigger.on("click", function (e) {
		e.preventDefault();

		// If none hidden yet, create new array
		if (hiddenAlerts == null) {
			hiddenAlerts = [];
		}

		// Add alert id to array
		hiddenAlerts.push(alertId);

		// Save hidden alerts array back to local storage
		localStorage.setItem("hidden-alerts", JSON.stringify(hiddenAlerts));

		// Hide alerts
		alert.addClass(headerAlertHiddenClass);
	});
});

// GIFT VOUCHER OPTIONS

const voucherAmount = $("[data-voucher-amount]");
const voucherNote = $("[data-voucher-note]");
const voucherDeliveryAdditional = $("[data-voucher-delivery-option-additional]");
const voucherDeliveryAdditionalActiveClass = "product-detail__delivery-options--active";

// When voucher delivery option checked
$("[data-voucher-delivery-option]").on("change", function () {
	// Remove active class from delivery additional boxes
	voucherDeliveryAdditional.removeClass(voucherDeliveryAdditionalActiveClass).attr("disabled", "true");

	// Get type of delivery selected
	let deliveryType = $(this).val();

	// Show selected type additional info
	let deliveryTypeExtra = $("[data-voucher-delivery-option-additional=" + deliveryType + "]")
		.addClass(voucherDeliveryAdditionalActiveClass)
		.removeAttr("disabled");
});

// BASKET DELETE LINE ITEM ----------------------------------------------

$("[data-delete-line-item]").on("click", function () {
	$(this).next("input").prop("checked", true);
	$(this).parents("form").submit();
});

// NUMBER PICKER --------------------------------------------------------

function updateNumberPicker(el, direction) {
	let numberEl = el.find("[data-number-picker-number]");
	let field = el.find("[data-number-picker-field]");
	let decreaseBtn = el.find("[data-number-picker-decrease]");
	let increaseBtn = el.find("[data-number-picker-increase]");
	let lowestNum = el[0].hasAttribute("data-number-picker-lowest") ? el.attr("data-number-picker-lowest") * 1 : 0;
	let highestNum = el[0].hasAttribute("data-number-picker-highest") ? el.attr("data-number-picker-highest") * 1 : 99999;

	// Increment or decrement number based on direction
	let number = field.val() * 1;
	switch (direction) {
		case "decrease":
			number--;
			break;

		case "increase":
			number++;
	}

	// Amend number in picker
	numberEl.html(number);
	field.val(number).trigger("change");

	// Enable/disable buttons based on lowest/highest limits
	if (number == lowestNum) {
		decreaseBtn.attr("disabled", true);
	} else {
		decreaseBtn.removeAttr("disabled");
	}

	if (number == highestNum) {
		increaseBtn.attr("disabled", true);
	} else {
		increaseBtn.removeAttr("disabled");
	}

	// If number picker is part of group, make sure all group fields don't exceed group max
	if (el[0].hasAttribute("data-number-picker-group")) {
		checkNumberPickerGroup(el);
	}
}

function checkNumberPickerGroup(el) {
	// Get group name and max
	let groupName = el.attr("data-number-picker-group");
	let groupMax = el.attr("data-number-picker-group-max") * 1;

	let groupTotal = 0;
	$('[data-number-picker-group="' + groupName + '"]').each(function () {
		let num = $(this).find("[data-number-picker-field]").val() * 1;
		groupTotal += num;
	});

	// If group total greater than max allowed, decrease one of groups other fields by amount
	if (groupTotal > groupMax) {
		console.log("Gone over max");

		// Amount to decrease other field by (should always be 1 in theory)
		let diff = groupMax - groupTotal;

		let otherGroupFlds = $('[data-number-picker-group="' + groupName + '"]').not(el);
		let nextGroupElFld = otherGroupFlds.first();

		updateNumberPicker(nextGroupElFld, "decrease");
	}
}

$("[data-number-picker]").each(function () {
	let el = $(this);
	let currNum = el.attr("data-number-picker") * 1;
	let decreaseBtn = el.find("[data-number-picker-decrease]");
	let increaseBtn = el.find("[data-number-picker-increase]");

	decreaseBtn.on("click", function (e) {
		updateNumberPicker(el, "decrease");
	});
	increaseBtn.on("click", function (e) {
		updateNumberPicker(el, "increase");
	});
});

// UPDATE BASKET AJAX -----------------------------------------------

// When quantity field in basket changes

$("[data-basket] [data-number-picker] input").change(function (e) {
	$(this).parents("[data-basket]").submit();
});

// $("[data-basket] [data-number-picker] input").change(function(e) {
// 	let formFlds = $(this)
// 		.parents("[data-basket]")
// 		.serializeArray();

// 	let headers = {
// 		"Content-Type": "application/x-www-form-urlencoded"
// 	};

// 	// axios.post('/', formFlds, {headers: headers})
// 	//     .then(function(response) {
// 	//         console.log(response);
// 	//     });
// 	$.ajax({
// 		method: "POST",
// 		dataType: "json",
// 		headers: headers,
// 		url: "/",
// 		data: formFlds,
// 		success: function(response) {
// 			console.log(response);

// 			if (response.success) {
// 				// Get cart object from response
// 				let cart = response.cart;

// 				// Update line item totals
// 				$.each(cart.lineItems, function(key, value) {
// 					$('[data-basket-line-item-total="' + key + '"]').html(
// 						formatCurrency(value.total, cart.currency)
// 					);
// 				});

// 				// Update basket totals
// 				$("[data-basket-subtotal]").html(
// 					formatCurrency(cart.itemSubtotal, cart.currency)
// 				);
// 				$("[data-basket-total-discount]").html(
// 					formatCurrency(cart.totalDiscount, cart.currency)
// 				);
// 				$("[data-basket-total]").html(
// 					formatCurrency(cart.totalPrice, cart.currency)
// 				);
// 			}
// 		}
// 	});
// });

function formatCurrency(num, currencyCode = "GBP") {
	return new Intl.NumberFormat("en-GB", {
		style: "currency",
		currency: currencyCode,
	}).format(num);
}

// FITVIDS -------------------------------------------

const fitvids = require("fitvids");
fitvids(".figure--video .figure__media");

// RECAPTCHA -----------------------------------------

grecaptcha.ready(function () {
	$("[data-form]").one("submit", function (e) {
		e.preventDefault();

		// Get action to send with token request
		let form = $(this);
		let action = $(this).attr("data-form");

		// Find token field in this form
		let tokenFld = $(this).find("[data-form-token]");

		// If token field found
		if (tokenFld.length) {
			// Request recaptcha token
			grecaptcha
				.execute("6LfuVZQUAAAAAKrkDLK_rVew9ZCgqDJAdGzoUgWo", {
					action: action,
				})
				.then(function (token) {
					// Add token to token field
					tokenFld.val(token);

					// Submit form
					form.submit();
				});
		}
	});
});

// ADDRESS STATES FIELD

const stateFld = $("[data-state-field]");
const stateFldHolder = $("[data-state-field-holder]");
const countryFld = $("[data-country-field]");

// If states array available, and state/country fields present
if (typeof states !== "undefined" && stateFld.length && stateFldHolder.length && countryFld.length) {
	console.log("STATES A GO GO");
	countryFld.on("change", function () {
		checkForStates($(this).val());
	});

	function checkForStates(countryId) {
		// If countryId exists as key in states array
		if (states.hasOwnProperty(countryId)) {
			// Remove current state options
			stateFld.find("option").remove();

			// Loop through states and add to state list
			for (let id in states[countryId]) {
				let state = states[countryId][id];
				let $option = $("<option/>");
				$option.attr("value", id).text(state);
				stateFld.append($option);
			}

			// Display state field
			stateFldHolder.removeAttr("style");
		} else {
			// Hide state field
			stateFldHolder.css("display", "none");

			// Remove current state options
			stateFld.find("option").remove();

			// Append blank option
			let $option = $("<option/>");
			$option.attr("value", "").text("");
			stateFld.append($option);
		}
	}
}

// IMG PICKER --------------------------------------------
let srcSets = [];
let sizes = [];
let srcs = [];
let selIndex = 0;
let triggerActiveClass = "thumb-btn--active";

$("[data-img-picker]").each(function () {
	let el = $(this);
	let allThumbs = $(this).find("[data-img-picker-trigger]");
	let nav = $(this).find("[data-img-picker-btn]");

	// Create arrays of srcset, sizes and src attributes from element
	srcSets = $(this).attr("data-img-picker-srcsets").split("|");
	sizes = $(this).attr("data-img-picker-sizes").split("|");
	srcs = $(this).attr("data-img-picker-srcs").split("|");

	// Thumbnails
	allThumbs.on("click", function () {
		allThumbs.removeClass(triggerActiveClass);
		selIndex = $(this).attr("data-img-picker-trigger") * 1;
		changeImgPicker(el, selIndex);
		$(this).addClass(triggerActiveClass);
	});

	// Nav btns
	nav.on("click", function () {
		// Remove thumbs active state
		allThumbs.removeClass(triggerActiveClass);

		// Find which direction btn was clicked
		let dir = $(this).attr("data-img-picker-btn");

		// Increment/decrement selected image based on direction
		switch (dir) {
			case "next":
				selIndex++;
				break;
			case "prev":
				selIndex--;
		}

		// Make sure we loop back to start/end of images when relevant
		if (selIndex < 0) {
			selIndex = allThumbs.length - 1;
		} else if (selIndex == allThumbs.length) {
			selIndex = 0;
		}

		// Change image
		changeImgPicker(el, selIndex);

		// Highlight correct thumb
		allThumbs.eq(selIndex).addClass(triggerActiveClass);
	});
});

/**
 * Changes image in ImgPicker component
 * @param  {Object} el jQuery element
 * @param  {number} i  Index of image to show
 * @return {void}
 */
function changeImgPicker(el, i) {
	let img = el.find("[data-img-picker-target]");
	img.attr({
		srcset: srcSets[i],
		sizes: sizes[i],
		src: srcs[i],
	});
}

// FAQS -------------------------------------

import faqs from "./modules/faqs.js";
faqs();

// ACCORDION -------------------------------------

import accordion from "./modules/accordion.js";
accordion();

// SUBNAV -------------------------------------

import subnav from "./modules/subnav.js";
subnav();

// ENQUIRY FORM -------------------------------------

import enquiryForm from "./modules/enquiry-form.js";
enquiryForm();

// When voucher extras option checked
// $("[data-voucher-option]").on('change', function() {
//
//     let totalAmount = voucherAmount.val() * 1;
//     let totalNotes  = (voucherNote.val() === '') ? [] : voucherNote.val().split('|');
//
//     let optionPrice = $(this).val() * 1;
//     let optionNote  = $(this).attr('data-voucher-option');
//
//     if ($(this).is(':checked')) {
//         totalAmount += optionPrice;
//         totalNotes.push(optionNote);
//     } else {
//         totalAmount -= optionPrice;
//         let i = totalNotes.indexOf(optionNote);
//         if (i !== -1) {
//             totalNotes.splice(i, 1);
//         }
//     }
//
//     voucherAmount.val(totalAmount)
//     voucherNote.val(totalNotes.join('|'));
// });

// const validation = require('bluegg-validation');
// const Nav = require('bluegg-nav');

// var mainNav = new Nav({
// 	nav: '.nav--primary',
// 	trigger: '#primary-nav-trigger'
// });

// var validation = new Validation({
// 	errorClass: 'form__row--error',
// 	fieldContainer: '.form__row'
// });

// FONT LOADING
// if (!document.documentElement.classList.contains('fonts-loaded')) {
// 	var fontA = new FontFaceObserver('helvetica', {
// 		weight: 'normal',
// 		style: 'normal'
// 	});
// 	var fontB = new FontFaceObserver('helvetica', {
// 		weight: 'normal',
// 		style: 'italic'
// 	});
// 	var fontC = new FontFaceObserver('helvetica', {
// 		weight: 'bold',
// 		style: 'normal'
// 	});
//
// 	Promise.all([fontA.load(), fontB.load(), fontC.load()]).then(function() {
// 		document.documentElement.className += ' fonts-loaded';
// 		createCookie('fonts-loaded', true);
// 	});
// }
// }

// SIGNUP FORM -------------------------------------

import signup from "./modules/signup.js";
signup();

import { initPlyr } from "./modules/plyr.js";
document.querySelectorAll("[data-plyr]").forEach((el) => initPlyr(el));
